export default __webpack_public_path__ + "static/media/paypal-wordmark-color.ef6f87b4.svg";